import '.bi{max-width:480px;}.ssr-plugin'
import '.ap{margin:0 auto;}.ssr-plugin'
import '.bn{margin-bottom:24px;}.ssr-plugin'
import '.b5{text-align:center;}.ssr-plugin'
import '.ce{font-size:16px;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'
import { Layout } from '../components/Layout.js'
import { Meter } from '../components/Meter.js'
import { Note } from '../components/Note.js'
import { Icon } from '../assets/icons/index.js'
import { colors } from '../utils/colors.js'
import { Background } from '../components/Background.js'
import { useDictionary } from '../hooks/useDictionary.js'

export const ProcessingPaymentPage = () => {
  const [value, setValue] = useState(0)
  const [showNote, setShowNote] = useState(false)

  const { processingPayment, processingMessage, processingLongWaitNotice } =
    useDictionary()

  useEffect(() => {
    const timeout = setTimeout(() => setValue(75), 100)
    return () => clearTimeout(timeout)
  }, [])

  useEffect(() => {
    const timeout = setTimeout(() => setShowNote(true), 13000)
    return () => clearTimeout(timeout)
  }, [])

  return (
    <>
      <Layout>
        <div className="bi ap">
          <Meter
            value={value}
            simulated
            style={{
              maxWidth: 160,
              margin: '0 auto',
              marginBottom: 48,
            }}
          />
          <h2 className="bn b5">
            {processingPayment}
          </h2>
          <p className="ce b5">
            {processingMessage}
          </p>
          {showNote && (
            <Note
              leadIcon={<Icon type="infoIcon" color={colors.orange} />}
              style={{
                marginTop: 48,
                maxWidth: 480,
                '& p': { fontSize: 16, textAlign: 'left' },
              }}
            >
              {processingLongWaitNotice}
            </Note>
          )}
        </div>
      </Layout>
      <Background type="payment" />
    </>
  )
}
